import React from 'react';
import { getCurrentDateInMillis, getDescription, getSpecificDateInMillis } from '../../../helpers/utils';
import { usePager } from '../../../helpers/pagination';
import { CongratulationsRunner } from '../CongratulationsRunner';
import PageIndicator from '../../Common/PageIndicator';
import SideBar from '../../Common/SideBar';
import Row from './Row';
import SpotlightHeader from '../../Common/Header';
import './AvgCheckSize.scss';
const text_description = 'check size';
const getFormattedData = (data, metadata) => {
  var _metadata$boh_date_ra;
  const {
    timezone,
    last_row: last_date
  } = data;
  const {
    boh_period,
    boh_date_range,
    results,
    boh_event_type
  } = metadata;
  const {
    endDate,
    endTime
  } = (_metadata$boh_date_ra = metadata.boh_date_range) !== null && _metadata$boh_date_ra !== void 0 ? _metadata$boh_date_ra : {};
  const description = getDescription(timezone, boh_event_type, boh_period, boh_date_range, text_description, last_date);
  const employees = data.employees.slice(0, results);
  const topEmployeeName = employees[0].employee;
  const showCongratulations = boh_event_type === 'custom' && endDate && endTime && getCurrentDateInMillis(timezone) > getSpecificDateInMillis(endDate, endTime, timezone);
  const hide_poweredbyshift = metadata.hide_poweredbyshift;
  return {
    description,
    employees,
    topEmployeeName,
    showCongratulations,
    hide_poweredbyshift
  };
};
const AvgCheckSize = props => {
  const {
    data,
    metadata,
    text,
    duration,
    playing,
    bohStyle
  } = props;
  const {
    accent_color,
    text_accent_color,
    title_color,
    title_font_family,
    containerStyle,
    listHeaderRowStyle
  } = bohStyle;
  const {
    employees,
    topEmployeeName,
    description,
    showCongratulations,
    hide_poweredbyshift
  } = getFormattedData(data, metadata);
  const [page, pageIdx, pages] = usePager(employees, duration * 1000, showCongratulations ? false : playing);
  const Header = /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata,
    description: description,
    isLeaderboard: true
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "avg-employees-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(CongratulationsRunner, {
    color: accent_color,
    textColor: title_color,
    firstText: "CONGRATULATIONS!",
    secondText: topEmployeeName,
    header: Header,
    timeout: (duration - 5) * 1000,
    showCongratulations: playing && showCongratulations
  }, /*#__PURE__*/React.createElement("div", {
    className: "width-container"
  }, Header, /*#__PURE__*/React.createElement("div", {
    className: "avg-ticket-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-row list-header",
    style: listHeaderRowStyle
  }, /*#__PURE__*/React.createElement("p", null, "Employee"), /*#__PURE__*/React.createElement("p", null, "Dollar Amount")), page.map((e, index) => /*#__PURE__*/React.createElement(Row, {
    key: `${e.employee}-${index}`,
    employee: e,
    accent_color: accent_color,
    text: text
  }))), !showCongratulations && pages.length > 1 && /*#__PURE__*/React.createElement(PageIndicator, {
    pages: pages,
    current: pageIdx,
    selectedColor: accent_color
  })), /*#__PURE__*/React.createElement(SideBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    logo: metadata.logo,
    text: text.message_board,
    fontFamily: title_font_family,
    hide_poweredbyshift: hide_poweredbyshift
  })));
};
export default AvgCheckSize;